<template>
  <BreadCrumb PageTitle="Demandes de changement de téléphone" />
  <PhoneRequests />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BreadCrumb from "../../../components/Common/BreadCrumb.vue";
import PhoneRequests from "../../../components/Customers/Demandes/PhoneRequests.vue";

export default defineComponent({
  name: "PhoneRequestsPage",
  components: {
    BreadCrumb,
    PhoneRequests,
  },

   
});
</script>